import styled from "styled-components";

export const DamInput = styled.div`
  display: flex;
  .dam-prefix {
    align-items: center;
    background-color: ${(props) => props.theme.colors.primaryBlue};
    border-radius: 1rem 0 0 1rem;
    color: ${(props) => props.theme.colors.white};
    display: flex;
    font-size: 1.5rem;
    font-weight: 500;
    justify-content: center;
    padding-left: 0.5rem;
    width: 10.5rem;
  }
  .dash-separator {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 1rem;
  }
  *:focus {
    outline: none;
  }
`;

interface IDamSuffix {
  hasError?: any;
}
export const DamSuffix = styled.input<IDamSuffix>`
  ${(props) => `
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height ? props.height : "4.5rem"};
  `}
  box-sizing: border-box;
  border-radius: 0 0.8rem 0.8rem 0;
  font-size: 1.5rem;
  font-weight: 500;
  margin-left: 0;
  padding-left: 1.5rem;
  width: 9rem;
  ::placeholder {
    color: ${(props) => props.theme.colors.gray72};
  }
`;

interface IDamExtension {
  hasError?: any;
}
export const DamExtension = styled.input<IDamExtension>`
  ${(props) => `
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height ? props.height : "4.5rem"};
  `}
  box-sizing: border-box;
  border-radius: 0.8rem;
  font-size: 1.5rem;
  font-weight: 500;
  padding-left: 1.5rem;
  width: 5rem;
  ::placeholder {
    color: ${(props) => props.theme.colors.gray72};
  }
`;
